/*
 * @Author: your name
 * @Date: 2021-09-16 11:31:05
 * @LastEditTime: 2025-02-08 09:53:27
 * @LastEditors: luodongming
 * @Description: In User Settings Edit
 * @FilePath: \yelink-ecm-developer-web\src\main.js
 */
import Vue from 'vue'

import Cookies from 'js-cookie'
import i18n from './lang' // internationalization
import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
import hdCopy from '@/utils/clipboard'

import './icons' // icon
import './utils/error-log' // error log

import * as filters from './filters' // global filters
import { hasPermission, hasNoPermission, hasAnyPermission } from './utils/permissionDirect'
import VueKeyCloak from '@dsb-norge/vue-keycloak-js'
import './assets/iconfont/iconfont.css'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
const Plugins = [
  hasPermission,
  hasNoPermission,
  hasAnyPermission
]

const setupStorageSync = (vm) => {
  // 监听storage变化
  window.addEventListener('storage', function(e) {
    if (e.key === 'developerOrganizationId') {
      // 触发全局事件，让各个组件响应
      vm.$bus.$emit('developerOrganizationIdUpdated', {
        key: e.key,
        newValue: e.newValue,
        oldValue: e.oldValue
      })
    }
    if (e.key === 'loginUserName') {
      // 触发全局事件，让各个组件响应
      vm.$bus.$emit('loginUserNameUpdated', {
        key: e.key,
        newValue: e.newValue,
        oldValue: e.oldValue
      })
    }
  })
}
// 创建事件总线
Vue.prototype.$bus = new Vue()

Plugins.map((plugin) => {
  Vue.use(plugin)
})

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false
Vue.prototype.hdCopy = (text) => {
  hdCopy(text)
  document.getElementById('app').click()
}

Vue.use(VueKeyCloak, {
  init: {
    onLoad: process.env.VUE_APP_KEYCLOAK_OPTIONS_ONLOAD,
    checkLoginIframe: false
  },
  config: {
    realm: process.env.VUE_APP_KEYCLOAK_OPTIONS_REALM,
    url: process.env.VUE_APP_KEYCLOAK_OPTIONS_URL,
    clientId: process.env.VUE_APP_KEYCLOAK_OPTIONS_CLIENTID
  },
  onReady: kc => {
    store.dispatch('account/keycloakLogin', kc.token)
    store.dispatch('account/getKeycloakInfo', null)
    new Vue({
      el: '#app',
      router,
      store,
      i18n,
      created() {
        setupStorageSync(this)
      },
      render: h => h(App)
    })

    //  Token Refresh
    setInterval(() => {
      kc.updateToken(70).then((refreshed) => {
        if (refreshed) {
          console.log('Token refreshed' + refreshed)
        }
      }).catch(() => {
        console.error('Failed to refresh token')
      })
    }, 6000)
  }
})

